/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useHomeData } from '../hooks/useHomeData';
import Load from './load';
import TestimonalSliderClient from './testimonialsilderclient';
import PureCounter from '@srexi/purecounterjs';

// Import optimized components
import HomeCarousel from '../components/home/HomeCarousel';
import VideoSection from '../components/home/VideoSection';
import FeaturesSection from '../components/home/FeaturesSection';
import StatsSection from '../components/home/StatsSection';
import AboutGroSection from '../components/home/AboutGroSection';
import ProgressiveLoader from '../components/about/ProgressiveLoader';
import LazySection from '../components/about/LazySection';
import LazySectionAbout from '../components/aboutnv/useAboutLazySection';
import { getAboutStart } from '../api/about/abouthook';
import StatsSectionn from '../components/aboutnv/StatsSection';
import fetchAPI from '../helper/axios';
const Home: React.FC = () => {
  const { data, loading, error, loadingProgress, retry } = useHomeData();
  
  //console.log(data?.video);
  // Carousel state
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexM, setCurrentIndexM] = useState(0);
  // Carousel navigation functions
  const nextSlide = () => {
    if (data?.hero?.desktopSlider?.slider_images) {
      setCurrentIndex((prev) => (prev + 1) % data.hero.desktopSlider!.slider_images.length);
    }
  };
  
  const prevSlide = () => {
    if (data?.hero?.desktopSlider?.slider_images) {
      setCurrentIndex((prev) => (prev - 1 + data.hero.desktopSlider!.slider_images.length) % data.hero.desktopSlider!.slider_images.length);
    }
  };
  
  const nextSlidem = () => {
    if (data?.hero?.mobileSlider?.slider_images) {
      setCurrentIndexM((prev) => (prev + 1) % data.hero.mobileSlider!.slider_images.length);
    }
  };
  
  const prevSlidem = () => {
    if (data?.hero?.mobileSlider?.slider_images) {
      setCurrentIndexM((prev) => (prev - 1 + data.hero.mobileSlider!.slider_images.length) % data.hero.mobileSlider!.slider_images.length);
    }
  };

  // Initialize PureCounter when component mounts
  useEffect(() => {
   
  }, [loading, data]);
const [googledata, setData] = useState<any>(null);
   
 localStorage.removeItem("media_No");
 localStorage.removeItem("site_key");   

useEffect(() => {
    const loadData = async () => {
      try {

        setData(await fetchAPI('node/68'));
    
      } catch (err: any) {
        
      } finally {
       
      }
    };

    loadData();
  }, [retry]);

  if(googledata){
    let  SITE_KEY = googledata.field_google_captcher_key[0].value ?? '';
    let Mediano = googledata.field_resource_pagination_no[0].value ?? 0;
    localStorage.setItem("site_key", SITE_KEY);
     localStorage.setItem("media_No", Mediano);
   
  }
  // Show progressive loader while loading
  if (loading && Object.values(loadingProgress).some(Boolean)) {
   // return <ProgressiveLoader loadingProgress={loadingProgress} />;
  }
  
  // if (error) {
  //   return (
  //     <div className="error-container">
  //       <h2>Something went wrong</h2>
  //       <p>{error}</p>
  //       <button onClick={retry}>
  //         Try Again
  //       </button>
  //     </div>
  //   );
  // }
   //console.log(data?.about?.data)
  if (!data) {
    return <div className="d-none">No data available</div>;
  }
 

  return ( 
  <>
     {/* <style>{`
         .header {
          --background-color: #003cff;
         }
      `}</style> */}
    <main className="main">
        {/* Desktop Carousel */}
        <HomeCarousel
          sliderData={data.hero?.desktopSlider}
          currentIndex={currentIndex}
          onNext={nextSlide}
          onPrev={prevSlide}
          onSlideChange={setCurrentIndex}
          isMobile={false}
        />

        {/* Mobile Carousel */}
        <HomeCarousel
          sliderData={data.hero?.mobileSlider}
          currentIndex={currentIndexM}
          onNext={nextSlidem}
          onPrev={prevSlidem}
          onSlideChange={setCurrentIndexM}
          isMobile={true}
        />

        {/* Video Section - Load immediately */}
        {data.video && (
          <VideoSection 
            data={data.video.data} 
            image={data.video.image} 
          />
        )}

 
        {/* About Section - Load when available */}
        {data.about && (
        // <section id="about" className="about section pt-3">
           <section id={`${!data?.video?.image?.status?.[0]?.value ? 'no-padding' : 'about'}` }
              className={`about  section ${
                data?.about?.data?.status?.[0]?.value ? '' : 'd-none' }  ` }
               
            >
               
          <div className="container" data-aos="fade-up" data-aos-delay="100">
              <div className="row gx-2 align-items-xl-start gy-md-5">
                  <div className="col-xl-8 content">
                  <label className="label-title">{data.about.data?.field_description?.[0]?.value}</label>
                  </div>
                  <div className="col-xl-4">
                      <div className="row gy-4 icon-boxes">
                          <div className="col-sm-12">
                      <p className="mb-0" dangerouslySetInnerHTML={{ __html: data.about.data?.field_content?.[0]?.value || '' }} />
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
        )}

        {/* Features Section - Lazy load */}
        {data.features && (
          <LazySection>
            <FeaturesSection 
              mainImage={data.features.mainImage}
              items={data.features.items || []}
              aboutData={data.about?.data}
            />
          </LazySection>
        )}

        {/* Stats Section - Lazy load */}
       {/* {data.stats && (
          <LazySection>
            <StatsSection 
              items={data.stats.items}
              backgroundImage={data.stats.backgroundImage}
            />
          </LazySection>
        )}*/}

         {/* Added as client want same stat section like about so used already existing about page data*/}
      {/*on 28-11-25 by dipali*/}
      <LazySectionAbout apiFunc={getAboutStart}>
        {(data: any) => <StatsSectionn data={data} />}
      </LazySectionAbout>

        {/*Already old data as i removed data api from deferred section so only empty section appear*/}
        {data.stats && (
          // <LazySection style={{ minHeight: "50px" }}>
            <StatsSection 
             items={data.stats.items}
              backgroundImage={data.stats.backgroundImage}
            />
        )}
        {/* About Gro Section - Lazy load */}
        {data.aboutGro && (
          <LazySection>
            <AboutGroSection 
              data={data.aboutGro.data}
              logo={data.aboutGro.logo}
              backgroundImage={data.aboutGro.backgroundImage}
            />
          </LazySection>
        )}

        {/* Testimonials */}
        {/* <TestimonalSliderClient /> */}
    </main>
  </>
  );
};

export default Home;